import { render, staticRenderFns } from "./_category_posts.vue?vue&type=template&id=3453c0f0&"
import script from "./_category_posts.vue?vue&type=script&lang=js&"
export * from "./_category_posts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports